import { EmptyState } from '@app/components/base/EmptyState';
import { Page } from '@app/components/page/Page';
import { ViewErrorActions } from '@mi-front/ui';
import LinkOffOutlinedIcon from '@mui/icons-material/LinkOffOutlined';
import { defineMessage, FormattedMessage, useIntl } from 'react-intl';

const routeNotFoundTitle = defineMessage({
  id: 'common.routeNotFound.title',
  defaultMessage: 'Esta página no existe',
});

const routeNotFoundHelp = defineMessage({
  id: 'common.routeNotFound.help',
  defaultMessage: 'El enlace puede estar roto o la página puede haberse movido.',
});

/**
 * Shown when the URL does not match any route, keeping the app chrome (sidenav) visible
 * instead of silently redirecting the user somewhere else.
 */
export function RouteNotFoundPage() {
  const { $t } = useIntl();

  return (
    <Page htmlTitle={$t(routeNotFoundTitle)}>
      <Page.Content>
        <EmptyState
          icon={LinkOffOutlinedIcon}
          message={<FormattedMessage {...routeNotFoundTitle} />}
          help={<FormattedMessage {...routeNotFoundHelp} />}
          action={<ViewErrorActions kind="notFound" />}
        />
      </Page.Content>
    </Page>
  );
}
